/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Previous_MatchInputs */

const en_read_along_previous_match = /** @type {(inputs: Read_Along_Previous_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous match`)
};

const es_read_along_previous_match = /** @type {(inputs: Read_Along_Previous_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coincidencia anterior`)
};

/**
* | output |
* | --- |
* | "Previous match" |
*
* @param {Read_Along_Previous_MatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_previous_match = /** @type {((inputs?: Read_Along_Previous_MatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Previous_MatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_previous_match(inputs)
	return en_read_along_previous_match(inputs)
});